import { BlocksIconMinus } from 'blocks-nextjs/blocks-web-components/components/icon/icons/minus';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMinus = createComponent({ react: React, tagName: 'cat-icon-minus', elementClass: BlocksIconMinus });
